<template>
  <div class="tw-pl-2 tw-pr-4">
    <div class="tw-pb-2 tw-inline-flex">
      <div class="tw-w-1/2 tw-mb-4 tw-flex-shrink-0 tw-px-1">
        <label class="tw-block tw-text-sm tw-mb-2 opacity-78 tw-text-left" for="color">
          Primary Color
        </label>
        <input
          class="tw-p-1 tw-w-full tw-rounded-sm tw-block tw-bg-gray-200 tw-outline-none transition hover:tw-bg-gray-200 focus:tw-bg-white tw-h-12"
          type="color"
          placeholder="Select Primary Color"
          name="color"
          v-model="color"
        >
      </div>
      <div class="tw-w-1/2 tw-mb-4 tw-flex-shrink-0 tw-px-1">
        <label class="tw-block tw-text-sm tw-mb-2 opacity-78 tw-text-left" for="color">
          Secondary Color
        </label>
        <input
          class="tw-p-1 tw-w-full tw-rounded-sm tw-block tw-bg-gray-200 tw-outline-none transition hover:tw-bg-gray-200 focus:tw-bg-white tw-h-12"
          type="color"
          placeholder="Select Primary Color"
          name="color2"
          v-model="color2"
        >
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-justify-end">
      <BaseButton
        text="Cancel"
        class="tw-border-0 tw-bg-app-black-11"
        @click="cancelEditing"
        :disabled="savingColor"
      />
      <BaseButton
        text="Save"
        class="tw-border-0 tw-bg-black tw-text-white tw-ml-2"
        @click="saveProgramColors"
        :disabled="savingColor"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditCompanyProgramColor',
  props: {
    companyProgram: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      color: this.companyProgram.color,
      color2: this.companyProgram.color2,
      colorError: undefined,
      savingColor: false,
    };
  },
  methods: {
    cancelEditing() {
      this.$emit('cancel-editing');
    },
    async saveProgramColors() {
      if (!this.color || !this.color2) return;

      this.savingColor = true;

      const formData = {
        progid: this.companyProgram.id,
        color: this.color,
        color2: this.color2,
      };

      const response = await this.$store.dispatch('editProgramColors', formData);

      if (!response) {
        this.$toasted.global.appError({ errorMessage: 'Could not save new program color' });
      } else {
        this.$toasted.success('Program color saved', {
          duration: 3500,
          position: 'top-right',
        });

        this.$emit('color-saved');
      }

      this.savingColor = false;
    },
  },
};
</script>

<style>

</style>
